import React from "react";
import { Linkedin, Instagram, Mail, BookOpen } from "lucide-react";
import { socialButtons, profile } from "../mock";

const iconMap = {
  linkedin: Linkedin,
  instagram: Instagram,
  substack: BookOpen,
  email: Mail,
};

const Footer = () => {
  return (
    <footer className="bg-white">
      <div className="mx-auto max-w-7xl px-6 py-14 lg:px-10">
        <div className="mb-3 inline-block border-[3px] border-black bg-white px-3 py-1 font-mono text-[11px] font-bold uppercase tracking-widest text-black shadow-[4px_4px_0px_0px_#00FF41]">
          // social_control_center
        </div>

        <h3 className="font-heading text-3xl font-extrabold leading-tight tracking-tight text-black sm:text-4xl">
          {profile.tagline}
        </h3>

        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-4">
          {socialButtons.map((s) => {
            const Icon = iconMap[s.id];
            return (
              <a
                key={s.id}
                href={s.href}
                target={s.id === "email" ? undefined : "_blank"}
                rel="noopener noreferrer"
                className="group flex items-center justify-between gap-3 border-[3px] border-black bg-white px-4 py-4 shadow-[4px_4px_0px_0px_#000000] transition-transform duration-150 hover:-translate-x-[2px] hover:-translate-y-[2px] hover:bg-[#00FF41] hover:shadow-[6px_6px_0px_0px_#000000] active:translate-x-[2px] active:translate-y-[2px] active:shadow-[0px_0px_0px_0px_#000000]"
              >
                <span className="font-mono text-sm font-bold uppercase tracking-wider text-black">
                  {s.label}
                </span>
                <span className="flex h-9 w-9 items-center justify-center border-[3px] border-black bg-[#00FF41] group-hover:bg-white">
                  <Icon className="h-4 w-4 text-black" strokeWidth={2.5} />
                </span>
              </a>
            );
          })}
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t-[3px] border-black pt-6 sm:flex-row sm:items-center">
          <span className="font-mono text-xs uppercase tracking-widest text-black">
            © {new Date().getFullYear()} Manthan Dhotre — All systems operational
          </span>
          <span className="font-mono text-xs uppercase tracking-widest text-black">
            <span className="mr-2 inline-block h-2 w-2 border-[1.5px] border-black bg-[#00FF41]" />
            status: online
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
